module.exports = __webpack_public_path__ + "static/media/receive-success-mouse5.30e17de1.png";